export const saleTemplate ={
    customer: { id: null },
    date:new Date(),
    products: [{
        quantity: 1
    }],
    amount: 0.0
}